import * as tslib_1 from "tslib";
import { BUTTON_KINDS } from "../../../consts/button";
import cx from 'classnames';
import { isFunction, noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withFocusedState from "../../../enhancers/withFocusedState";
import "./Button.css";

var Button =
/** @class */
function (_super) {
  tslib_1.__extends(Button, _super);

  function Button() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      hovered: false,
      pressed: false
    };

    _this.handleMouseEnter = function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        hovered: true
      });

      _this.props.onMouseEnter(event);
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        hovered: false,
        pressed: false
      });

      _this.props.onMouseLeave(event);
    };

    _this.handleMouseDown = function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        pressed: true
      });

      if (!_this.props.focused) {
        // force focus for firefox on mouse click, because firefox ignores that one
        setTimeout(function () {
          return _this.elem && isFunction(_this.elem.focus) && _this.elem.focus();
        }, 4);
      }

      _this.props.onMouseDown(event);
    };

    _this.handleMouseUp = function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        pressed: false
      });

      _this.props.onMouseUp(event);
    };

    _this.handleClick = function (event) {
      if (_this.props.disabled) return;

      _this.props.onClick(event);
    };

    _this.ref = function (ref) {
      return _this.elem = ref;
    };

    return _this;
  }

  Button.prototype.componentWillReceiveProps = function (nextProps) {
    if (nextProps.disabled) {
      this.setState({
        hovered: false,
        pressed: false
      });
    }
  };

  Button.prototype.render = function () {
    var _a;

    var _b = this.props,
        kind = _b.kind,
        type = _b.type,
        disabled = _b.disabled,
        Component = _b.component,
        //tslint:disable-line
    blockName = _b.blockName,
        className = _b.className,
        focused = _b.focused,
        isTwoLine = _b.isTwoLine,
        autoHeight = _b.autoHeight,
        onFocus = _b.onFocus,
        onBlur = _b.onBlur,
        other = tslib_1.__rest(_b, ["kind", "type", "disabled", "component", "blockName", "className", "focused", "isTwoLine", "autoHeight", "onFocus", "onBlur"]);

    var _c = this.state,
        hovered = _c.hovered,
        pressed = _c.pressed;
    var finalClassName = cx(blockName, (_a = {}, _a[blockName + "--" + kind] = kind, _a[blockName + "--disabled"] = disabled === true, _a[blockName + "--two-line"] = isTwoLine, _a[blockName + "--auto-height"] = autoHeight, _a[blockName + "--active"] = focused, _a[blockName + "--hover"] = hovered && !focused, _a[blockName + "--hover-active"] = hovered && focused, _a[blockName + "--press"] = pressed, _a), className);
    return React.createElement(Component, tslib_1.__assign({}, tslib_1.__assign({}, other, {
      type: ['button', 'input'].includes(Component) ? type : undefined,
      disabled: disabled,
      className: finalClassName,
      ref: this.ref,
      onClick: this.handleClick,
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp
    })));
  };

  Button.propTypes = {
    type: PropTypes.string,
    kind: PropTypes.oneOf(BUTTON_KINDS),
    disabled: PropTypes.bool,

    /**
     * Sometimes we need other tags for rendering "button". (e.g. when we have nested clickable)
     * like http://stackoverflow.com/questions/26402033/missing-click-event-for-span-inside-button-element-on-firefox
     * React factory or string corresponding to a default JSX element
     * The component prop will be passed to React.createElement()
     */
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    blockName: PropTypes.string,

    /** Unlike blockName, it comes to `class` of `<button>` only once, without state modifiers. */
    className: PropTypes.string,
    focused: PropTypes.bool,

    /** Sets a fixed height of 48px and wraps text into two lines */
    isTwoLine: PropTypes.bool,

    /** Dynamic height with 8px top and bottom paddings */
    autoHeight: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    onClick: PropTypes.func
  };
  Button.defaultProps = {
    type: 'button',
    kind: 'default',
    disabled: false,
    component: 'button',
    blockName: 'nx-button',
    focused: false,
    isTwoLine: false,
    autoHeight: false,
    onFocus: noop,
    onBlur: noop,
    onMouseEnter: noop,
    onMouseLeave: noop,
    onMouseDown: noop,
    onMouseUp: noop,
    onClick: noop
  };
  return Button;
}(Component);

export default withFocusedState(Button);

try {
  // @ts-ignore
  Button.__docgenInfo = {
    "description": "",
    "displayName": "Button",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}